import { useAxios } from "@hooks"
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

export const useGetExamInstanceQuestion = (id?: string) => {

    const axios = useAxios();
    const { t } = useTranslation();

    const getExamInstanceQuestion = async () => {
        try {
            const response = await axios.get(`/api/ExamInstanceQuestion/${id}`);
            return response.data;
        } catch (error) {
            throw new Error(t("messages.error.examInstanceQuestion"));
        }
    }

    return useQuery({ queryKey: ["examInstanceQuestion", id], queryFn: getExamInstanceQuestion, enabled: !!id, staleTime: Infinity});
}